// @ts-nocheck
import useGetCurrentProduct from "@store/Framework/Store/Data/Products/ProductsHooks/useGetCurrentProduct";
import InfosBox, { InfosBoxStyles } from "@store/Library/Components/Toolkit/InfosBox";
import StyledWrapper from "@insite/client-framework/Common/StyledWrapper";
import { AvailabilityDto } from "@insite/client-framework/Types/ApiModels";
import Typography from "@insite/mobius/Typography";
import InjectableCss from "@insite/mobius/utilities/InjectableCss";
import useGetInventory from "@store/Framework/Store/Data/Products/ProductsHooks/useGetInventory";
import useIsProductRestricted from "@store/Framework/Store/Data/Products/ProductsHooks/useIsProductRestricted";
import ProductStatusMessage from "@store/Library/Components/ProductAvailability/ProductStatusMessage";
import { getStatusColor } from "@store/Overrides/Components/ProductAvailability";
import { statusStyles } from "@store/Themes/common/mixins/status";
import useMergeProps from "@toolkit/Framework/Common/Hooks/useMergeProps";
import React, { useMemo } from "react";
import { css } from "styled-components";

export interface ProductDetailsMessageStyles {
    wrapper?: InjectableCss;
    typography?: InjectableCss;
}
type ProductDetailMessageProps =
    | {
          availability?: never;
          extendedStyles?: ProductDetailsMessageStyles;
          isRestricted?: never;
      }
    | {
          availability?: AvailabilityDto;
          isRestricted: boolean;
          extendedStyles?: ProductDetailsMessageStyles;
      };

const productDetailMessageStyles: ProductDetailsMessageStyles = {
    wrapper: {
        css: css`
            width: fit-content;
        `,
    },
};
const ProductDetailMessage: React.FC<ProductDetailMessageProps> = ({ availability, extendedStyles }) => {
    const styles = useMergeProps(productDetailMessageStyles, extendedStyles);
    const currentProduct = useGetCurrentProduct();
    const isProductRestricted = useIsProductRestricted(currentProduct.product);
    const propAvailabilityDetailMessage =
        availability?.infoMessage !== availability?.message ? availability?.infoMessage : undefined;

    const { availabilityDetailMessage, availabilityInfoMessageColor, availabilityInfoMessageIcon } = useGetInventory();

    const color = getStatusColor(availabilityInfoMessageColor ?? availability?.infoMessageColor);

    const availabilityDetailMessageToUse = propAvailabilityDetailMessage || availabilityDetailMessage;
    // If availibility is being passed as a prop is product restricted is always false
    if (!availabilityDetailMessageToUse || (!availability && isProductRestricted)) {
        return null;
    }

    return (
        <ProductStatusMessage
            messageColor={color ?? ""}
            messageIcon={availabilityInfoMessageIcon}
            message={availabilityDetailMessageToUse}
            extendedStyles={styles}
        />
    );
};

export default ProductDetailMessage;
